import React from 'react';

const TernaryButton = ({ label, href, className, children }) => {
    return <a
    href={href}
    className={"inline-flex text-gray-400 bg-black focus:outline-none text-lg " + className}>{label || children}</a>
}

export default TernaryButton;